<template>
  <div
    :class="$style.wrapper"
    :style="wrapperStyle"
    @click="handleClick"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BaseRoundedButton',
  props: {
    size: {
      type: Number,
      default: 55,
    },
  },
  computed: {
    wrapperStyle() {
      return {
        height: `${this.size}px`,
        width: `${this.size}px`,
      }
    },
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss" module>
  .wrapper {
    cursor: pointer;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
